module.exports = __webpack_public_path__ + "img/ChampionLA-Solicitation Package_p2.c7b89cd5.jpg";